<template>
  <div class="shoe" @click="detail" v-bind:class="{ even: !(index % 2) }">
    <img :src="imageicon" class="image" v-if="!loading && image" />

    <h2 class="title">{{ shoe.name }}</h2>

    <p class="price" v-if="!shoe.discount">€ {{ price }}</p>

    <div v-else>
      <del>
        <span class="price oldprice">€ {{ price }}</span>
      </del>
      <ins>
        <span v-if="shoe.discount" class="price"
          >€ {{ shoe.sales_price.toFixed(2) }}
        </span>
      </ins>
    </div>
  </div>
</template>

<script>
export default {
  name: "Shoe",
  props: ["shoe", "index"],
  data: function() {
    return {
      loading: true,
      image: ""
    };
  },
  methods: {
    detail: async function() {
      this.$router.push({ name: "details", params: { id: this.shoe._id } });
    }
  },
  computed: {
    price: function() {
      let price = parseFloat(this.shoe.price);
      return price.toFixed(2);
    },
    imageicon: function() {
      return process.env.VUE_APP_BACKEND + this.image.full;
    }
  },
  mounted: async function() {
    this.image = this.$store.getters.image(this.shoe.image);
    console.log(this.image);
    console.log(this.index);
    console.log(this.shoe);
    this.loading = false;
  }
};
</script>

<style scoped>
.even {
  background-color: #f4f4f4;
}

.shoe {
  width: 100%;
  display: grid;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  grid-template-columns: 140px 3fr 1fr;
}

.title {
  margin: 0;
  padding: 0;
  text-align: left;
  font-weight: 100;
  font-size: 18px;
  flex-grow: 1;
  padding: 10px;
  font-weight: 500;
  grid-column: 2;
}

.image {
  border-radius: 50%;
  width: 90px;
  height: 90px;
  object-fit: cover;
  margin: 5px 20px;
  flex-grow: 2;
  box-shadow: 0px 3px 6px #d0d0d0;
}

.price {
  justify-self: center;
  flex-basis: 100px;
  font-weight: 300;
}

del {
  text-decoration: none;
  position: relative;
  width: 100%;
  display: block;
  margin-bottom: 10px;
}

ins {
  color: green;
  text-decoration: none;
  padding: 1em;
  font-size: 1.1em;
}
.oldprice {
  text-decoration: none;
  position: relative;
  color: red;
}

.oldprice::before {
  top: 50%; /*tweak this to adjust the vertical position if it's off a bit due to your font family */
  background: red; /*this is the color of the line*/
  opacity: 0.7;
  content: "";
  width: 110%;
  position: absolute;
  height: 0.1em;
  border-radius: 0.1em;
  left: -5%;
  white-space: nowrap;
  display: block;
  transform: rotate(-15deg);
}

.oldprice.straight::before {
  transform: rotate(0deg);
  left: -1%;
  width: 102%;
}
</style>
